import axios, { isAxiosError } from "axios";

import { FileNotFoundException } from "@byloth/core";

export interface ProjectPreviewData
{
    id: number;
    name: string;
    projectId: string;
}
export class ProjectPreview implements ProjectPreviewData
{
    public readonly id: number;
    public readonly name: string;
    public readonly projectId: string;

    public constructor(options: ProjectPreviewData)
    {
        this.id = options.id;
        this.name = options.name;
        this.projectId = options.projectId;
    }
}

export interface ProjectData extends ProjectPreviewData
{
    coverImage?: string;

    showLeaderboards: boolean;
    showQuizzes: boolean;
    showRealtime: boolean;
    showUsers: boolean;

    apiKey: string;
    authDomain: string;
    databaseUrl?: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
    appCheckKey?: string;

    colyseusServer?: string;

    authToken: string;
}
export default class Project extends ProjectPreview implements ProjectData
{
    public readonly coverImage?: string;

    public readonly showLeaderboards: boolean;
    public readonly showQuizzes: boolean;
    public readonly showRealtime: boolean;
    public readonly showUsers: boolean;

    public readonly apiKey: string;
    public readonly authDomain: string;
    public readonly databaseUrl?: string;
    public readonly storageBucket: string;
    public readonly messagingSenderId: string;
    public readonly appId: string;
    public readonly measurementId?: string;
    public readonly appCheckKey?: string;

    public readonly colyseusServer?: string;

    public readonly authToken: string;

    public constructor(options: ProjectData)
    {
        super(options);

        this.coverImage = options.coverImage;

        this.showLeaderboards = options.showLeaderboards;
        this.showQuizzes = options.showQuizzes;
        this.showRealtime = options.showRealtime;
        this.showUsers = options.showUsers;

        this.apiKey = options.apiKey;
        this.authDomain = options.authDomain;
        this.databaseUrl = options.databaseUrl;
        this.storageBucket = options.storageBucket;
        this.messagingSenderId = options.messagingSenderId;
        this.appId = options.appId;
        this.measurementId = options.measurementId;
        this.appCheckKey = options.appCheckKey;

        this.colyseusServer = options.colyseusServer;

        this.authToken = options.authToken;
    }

    public getAssetUrl(name: string): string
    {
        return `https://storage.googleapis.com/${this.storageBucket}/assets/${name}`;
    }

    public async loadAssetFile<T>(name: string, raiseIfNotFound?: true): Promise<T>;
    public async loadAssetFile<T>(name: string, raiseIfNotFound: false): Promise<T | undefined>;
    public async loadAssetFile<T>(name: string, raiseIfNotFound = true): Promise<T | undefined>
    {
        const configUrl = this.getAssetUrl(name);

        try
        {
            const response = await axios.get<T>(configUrl);

            return response.data;
        }
        catch (error)
        {
            if ((raiseIfNotFound) && isAxiosError(error))
            {
                throw new FileNotFoundException(configUrl, error);
            }

            return;
        }
    }
}
